import React from 'react'
import { Typography, Container, Button, Grid } from '@material-ui/core'
import useStyles from './styles'
import CardItem from './CartItem/CartItem'
import { Link } from 'react-router-dom'
const Cart = ({ cart, handleUpdateCartQty, handleRemoveFromCart, handleEmptyCart }) => {
    const classes = useStyles();

    const EmptyCart = () => (
        <>
        <Typography gutterBottom>Your Cart is Empty! start adding some...
        </Typography>
        <Button component={Link} to='/' variant='contained' type='button' color='secondary' >Back To Home Page</Button>
        </>
    );


    const FilledCart = () => (
        <>

        <Grid container spacing={4}>
            {cart.line_items.map(item => (
                <Grid item xs={12} sm={4} key={item.id}>
                    <CardItem item={item} handleUpdateCartQty={handleUpdateCartQty} handleRemoveFromCart={handleRemoveFromCart} />
                </Grid>
            ))}
        </Grid>
        <div className={classes.cardDetails}>
            <Typography variant='h4'>SubTotal = {cart.subtotal.formatted_with_symbol}</Typography>
            <div>
                <Button className={classes.emptyButton} size='large' type='button' variant='contained' color='secondary' onClick={handleEmptyCart}>Empty Cart</Button>
                <Button className={classes.checkoutButton} component={Link} to='/checkout' size='large' type='button' variant='contained' color='primary'>Checkout</Button>
            </div>
        </div>
        </>
    );
    if(!cart.line_items) return 'Loading ...'

    return (
        <Container>
            <div className={classes.toolbar} />
            <Typography className={classes.title} variant='h3' gutterBottom>Your Shopping Cart</Typography>
            { !cart.line_items.length ? <EmptyCart /> : <FilledCart />}
        </Container>
    )
}

export default Cart
